"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorLabel = void 0;
var ErrorLabel;
(function (ErrorLabel) {
    ErrorLabel["PASSWORD_REQUIREMENTS"] = "PasswordRequirements";
    ErrorLabel["PASSWORD_MISMATCH"] = "PasswordMismatch";
    ErrorLabel["ACCOUNT_ALREADY_EXISTS"] = "AccountAlreadyExists";
    ErrorLabel["ACCOUNT_NOT_FOUND"] = "AccountNotFound";
    ErrorLabel["WRONG_PASSWORD"] = "WrongPassword";
})(ErrorLabel || (exports.ErrorLabel = ErrorLabel = {}));
//# sourceMappingURL=ErrorLabel.js.map